'use strict';

var React = require('react');

var SvgSmileyNeutralMajor = function SvgSmileyNeutralMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.75a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 7.75a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
  }));
};
SvgSmileyNeutralMajor.displayName = "SmileyNeutralMajor";

exports.SvgSmileyNeutralMajor = SvgSmileyNeutralMajor;
